import { Box, Container, Group, Text } from '@mantine/core';

export function OfflineBanner() {
  return (
    <Box
      role="alert"
      aria-live="assertive"
      style={{
        padding: 'var(--space-3) var(--space-6)',
        backgroundColor: 'var(--amber-bg)',
        borderBottom: '1px solid var(--amber-accent)',
        position: 'relative',
        zIndex: 11,
      }}
    >
      <Container size="lg">
        <Group justify="center" gap={10}>
          <Box
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: 'var(--amber-accent)',
              boxShadow: '0 0 10px rgba(245, 158, 11, 0.55)',
              animation: 'kioskPulse 1.6s var(--ease-in-out) infinite',
              flexShrink: 0,
            }}
          />
          <Text
            fw={700}
            style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--amber-accent)',
              fontSize: '0.8125rem',
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
            }}
          >
            Offline — scans paused
          </Text>
          <Text
            fw={500}
            style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)',
              fontSize: '0.8125rem',
            }}
          >
            Reconnecting automatically. Tell your supervisor if this persists.
          </Text>
        </Group>
      </Container>
    </Box>
  );
}
